import * as React from "react";
import {Header} from "@/components/Header";

export const Membership = () => {
	return (
		<>
			<div className="w-full bg-white flex flex-col items-center justify-center">
				<Header/>
				<img
					src="/banners/banner-membership.jpg"
					alt="Information Banner"
					className="w-full object-cover shadow-lg"
				/>
			</div>
			<div className='mx-4 sm:mx-8 md:mx-16 lg:mx-24 my-10 flex justify-center'>
				<img
					src="/other_imgs/thumbnail-joglekarkul-nondnikara.png"
					alt="Membership Thumbnail"
					className="w-full max-w-lg object-contain"
				/>
			</div>
			<div
				className="flex flex-col md:flex-row md:items-center md:justify-center text-center gap-6 mt-10 md:px-16 lg:px-36 mb-16">
				<div className="flex flex-col items-center">
					<img src="/other_imgs/thumbnail-membership-dan-kara.png" alt="dana_kara"
					     className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl sm:text-2xl">उदारपणे दान करा</h2>
				</div>
				<div className="flex flex-col items-center">
					<img src="/other_imgs/thumbnail-membership-sadasya-yadi.png" alt="yadi"
					     className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl sm:text-2xl">विधमान सदस्यांची यादी</h2>
				</div>
				<div className="flex flex-col items-center">
					<img src="/other_imgs/thumbnail-membership-sadasya-shoda.png" alt="shoda"
					     className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80"/>
					<h2 className="font-custom-bold mt-5 text-red-700 text-xl sm:text-2xl">सदस्य शोध</h2>
				</div>
			</div>
		</>
	);
}
